const ServerHost = process.env.REACT_APP_SERVER_HOST
const Domain = process.env.REACT_APP_DOMAIN
const isDemo = process.env.REACT_APP_SERVER_STATE=='DEMO'
const Protocol = process.env.REACT_APP_PROTOCOL

const config = {
    WS_BASE_URL: `${Protocol}://${ServerHost}/api/`,
    DOMAIN_NAME: `${Protocol}://${Domain}/`,
    DEMO: isDemo
}

export default config;
